import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _hoisted_1 = { class: "topbar" }
const _hoisted_2 = { class: "sidebar-header" }
const _hoisted_3 = { class: "sidebar-links" }

import {ref} from "vue";

import {Home, Image, Info, Menu, MessageCircle, Phone, Wrench, X} from "lucide-vue-next";

import "@/assets/styles/sidebar.css";

import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarComponent',
  setup(__props) {

const router = useRouter();

const isOpen = ref(false);

const toggleSidebar = () => {
  isOpen.value = !isOpen.value;
};

const goTo = (target: string) => {
  isOpen.value = false;

  // Wenn Onepager Section
  if (target.startsWith("#")) {
    router.push("/").then(() => {
      setTimeout(() => {
        document.querySelector(target)?.scrollIntoView({
          behavior: "smooth"
        });
      }, 50);
    });
    return;
  }

  // Normale Route
  router.push(target);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "brand" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Logo",
          class: "brand-logo"
        }),
        _createElementVNode("div", { class: "brand-text" }, [
          _createElementVNode("h2", null, "TestGarten"),
          _createElementVNode("span", null, "Garten- & Landschaftsbau")
        ])
      ], -1)),
      _createElementVNode("button", {
        class: "menu-btn",
        onClick: toggleSidebar
      }, [
        _createVNode(_unref(Menu))
      ])
    ]),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "sidebar-overlay",
          onClick: toggleSidebar
        }))
      : _createCommentVNode("", true),
    _createElementVNode("aside", {
      class: _normalizeClass(["sidebar", { open: isOpen.value }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "brand" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Logo",
            class: "brand-logo"
          }),
          _createElementVNode("div", { class: "brand-text" }, [
            _createElementVNode("h2", null, "TestGarten"),
            _createElementVNode("span", null, "Garten- & Landschaftsbau")
          ])
        ], -1)),
        _createElementVNode("button", {
          class: "close-btn",
          onClick: toggleSidebar
        }, [
          _createVNode(_unref(X))
        ])
      ]),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goTo('#home')))
        }, [
          _createVNode(_unref(Home)),
          _cache[10] || (_cache[10] = _createTextVNode(" Home ", -1))
        ]),
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (goTo('#about')))
        }, [
          _createVNode(_unref(Info)),
          _cache[11] || (_cache[11] = _createTextVNode(" Über uns ", -1))
        ]),
        _createElementVNode("a", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (goTo('#services')))
        }, [
          _createVNode(_unref(Wrench)),
          _cache[12] || (_cache[12] = _createTextVNode(" Leistungen ", -1))
        ]),
        _createElementVNode("a", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (goTo('#review')))
        }, [
          _createVNode(_unref(MessageCircle)),
          _cache[13] || (_cache[13] = _createTextVNode(" Bewertungen ", -1))
        ]),
        _createElementVNode("a", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (goTo('#references')))
        }, [
          _createVNode(_unref(Image)),
          _cache[14] || (_cache[14] = _createTextVNode(" Referenzen ", -1))
        ]),
        _createElementVNode("a", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (goTo('#contact')))
        }, [
          _createVNode(_unref(Phone)),
          _cache[15] || (_cache[15] = _createTextVNode(" Kontakt ", -1))
        ]),
        _createElementVNode("a", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (goTo('/impressum')))
        }, " Impressum "),
        _createElementVNode("a", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (goTo('/datenschutz')))
        }, " Datenschutz ")
      ])
    ], 2)
  ], 64))
}
}

})